<template>
  <f7-page class="page-bot-free-create" @page:init="pageMounted" @page:reinit="pageMounted">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>TẠO BOT LẤY TIN</f7-nav-title>
    </f7-navbar>
    <template v-if="_.isEmpty(result)">
      <f7-list inset inline-labels>
        <f7-list-item title="Khách hàng" smart-select :smart-select-params="{openIn: 'popup', closeOnSelect: true}">
          <select name="customer" @change="changeCustomer($event.target.value)">
            <option value="">- Chọn -</option>
            <optgroup label="Khách">
              <option v-for="(cust, idx) in _.filter(customers, {type: 1})" :key="idx" :value="cust.id" :selected="form_bot.customer_id === cust.id">
                {{ cust.fullname }}
              </option>
            </optgroup>
            <optgroup label="Chủ">
              <option v-for="(cust, idx) in _.filter(customers, {type: 2})" :key="idx" :value="cust.id" :selected="form_bot.customer_id === cust.id">
                {{ cust.fullname }}
              </option>
            </optgroup>
          </select>
          <f7-icon slot="media" ios="f7:person" color="crimson"></f7-icon>
        </f7-list-item>
        <f7-list-input label="Nền tảng" type="select" @input="form_bot.bot_type = $event.target.value">
          <f7-icon slot="media" ios="f7:ant" color="crimson"></f7-icon>
          <option value="telegram_free_text">Telegram</option>
        </f7-list-input>
      </f7-list>
      <f7-block inset class="mt-1">
        <f7-button fill color="primary" @click.prevent="submitForm">XÁC NHẬN</f7-button>
      </f7-block>
      <f7-block strong inset class="alert-warning margin-bottom box-shadow mt-2" v-if="user_info.server_region === 'hanoi'">
        <p>Bước 1: Chọn khách hàng bạn muốn liên kết với nhóm bot.</p>
        <p>Bước 2: sau đó xác nhận. Bạn sẽ nhận được 1 dãy <b class="text-color-red">mã liên kết</b>. copy mã liên kết này lại.</p>
        <p>Bước 3:</p>
        <ul>
          <li>Vào ứng dụng telegram, bấm chọn tạo nhóm</li>
          <li>Sau đó seach user <b>@kos247_bot</b> add bot vào cùng với khách hàng của bạn. sau đó đặt tên nhóm</li>
        </ul>
        <p>Bước 4: bấm <b>/ketnoi</b> , nhập <b class="text-color-red">mã liên kết</b> bên trên để kết nối với phòng chat</p>
      </f7-block>
      <f7-block strong inset class="alert-warning margin-bottom box-shadow mt-2" v-else>
        <p>Bước 1: Chọn khách hàng bạn muốn liên kết với nhóm bot.</p>
        <p>Bước 2: sau đó xác nhận. Bạn sẽ nhận được 1 dãy <b class="text-color-red">mã liên kết</b>. copy mã liên kết này lại.</p>
        <p>Bước 3:</p>
        <ul>
          <li>Vào ứng dụng telegram, bấm chọn tạo nhóm</li>
          <li>Sau đó seach user <b>@kos247_bot</b> add bot vào cùng với khách hàng của bạn. sau đó đặt tên nhóm</li>
        </ul>
        <p>Bước 4: bấm <b>/ketnoi</b> , nhập <b class="text-color-red">mã liên kết</b> bên trên để kết nối với phòng chat</p>
      </f7-block>
    </template>
    <f7-block class="mt-0 mb-0" inset strong v-else>
      <h3 class="text-align-center">MÃ LIÊN KẾT BOT CỦA BẠN LÀ</h3>
      <div class="list form-list no-margin margin-bottom-half">
        <ul>
          <li class="item-content item-input item-input-with-value">
            <div class="item-inner">
              <div class="item-input-wrap">
                <input type="text" class="input-with-value" @focus="$event.target.select()" :value="result.data.connect_code"/>
              </div>
            </div>
            <div class="item-media">
              <button type="button" @click.prevent="copyCode" class="button button-44 text-color-theme margin-half">
                <f7-icon f7="doc_on_doc"></f7-icon>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </f7-block>
  </f7-page>
</template>
<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['customers', 'user_info']),
  },
  data() {
    return {
      form_bot: {
        customer_id: '',
        bot_type: 'telegram_free_text'
      },
      result: {}
    }
  },
  methods: {
    changeCustomer(cust_id) {
      this.form_bot.customer_id = cust_id;
    },
    submitForm() {
      let self = this;
      self.$f7.dialog.preloader();

      self.$store.dispatch('generateBotChatRoom', self.form_bot).then((res) => {
        self.result = res;
        this.$f7.dialog.close();
      }).catch((err) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    showToastBottom(text) {
      const self = this;
      if (!self.toastBottom) {
        self.toastBottom = self.$f7.toast.create({
          text: text,
          closeTimeout: 2000,
          position: 'bottom',
          horizontalPosition: 'center'
        });
      }
      self.toastBottom.open();
    },
    copyCode() {
      this.$copyText(this.result.data.connect_code);
      this.showToastBottom('Đã copy');
    },
  },
};
</script>
